import { PAGE_URL } from "@/api/system/dictionary-data";
import { Table } from "@/component-create/Table";
import { 
  createTableColumn,
  tableDeleteController,
  tableEditController,
} from "@/component-create/utils/create-table-column";
import { COMMON_ENABEL_STATUS } from "@/constant/system/code";
import { formatter } from "@/utils/common";

type Row = TColumnControls<'editFn' | 'deleteFn'>

export function renderTable(el: Element, table: Row, header: () => VNode) {
  const defaultColumn = [
    createTableColumn('数据名称', 'dataName'),
    createTableColumn('数据编码', 'dataCode'),
    createTableColumn('数据值', 'dataValue', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumn('顺序', 'sort', '80', 'center', { sortable: true }),
    createTableColumn('状态', 'status', '60', 'center', { formatter: (row) => formatter(COMMON_ENABEL_STATUS, row.status) }),
    createTableColumn('备注', 'remark', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumn('创建时间', 'createdAt', '140', undefined, { sortable: true, }),
    createTableColumn('操作', undefined, '180', 'center', {
      controller: [
        tableEditController(table.editFn),
        tableDeleteController(table.deleteFn)
      ]
    })
  ]

  const _table = new Table(el, defaultColumn, header, { border: true }, PAGE_URL, { autoLoad: false, showIndex: true, selectable: true })
  return _table
}
